module.exports = {
	list: [
		{
			label: 'finrockets.com',
			value: 'finrockets.com'
		}
	]
};


// WEBPACK FOOTER //
// ./frontend/shared/js/externalOfferDomains.js